import React, { useState, useRef, useEffect } from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateLastWord } from "../Slice/slice";
import "./drop.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";
import { listAvatar, getAvatarLibrary } from "../api/accountAction";
import { setLibraryQuestion } from "../Slice/reducer/chatReducer";

function MentionInputField(props) {
  const dispatch = useDispatch();
  const lastWord = useSelector((state) => state.lastWord);
  const [mentions, setMentions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [queryshow, setqueryshow] = useState(false);
  const [queryqusestions, setqueryquestions] = useState([]);
  const editorRef = useRef(null);
  const navigateFn = useNavigate();
  const [searchtext, setSearchtext] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [value, setValue] = useState("");
  const [avatarname, setavatarname] = useState([]);
  const [allowlist, setAllowListStatus] = useState(true);
  const companyName = atob(
    localStorage.getItem("AIVolveXIdentityServiceProvider.com")
  );
  const userName = atob(
    localStorage.getItem("AIVolveXIdentityServiceProvider.auth")
  );
  const [filteredSuggestionsqus, setfilteredSuggestionsqus] = useState([]);
  const [id, setid] = useState();
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [clicked, setClicked] = useState(false);
  const [searchquerystatus, setSearchQueryStatus] = useState(false);
  useEffect(() => {
    const input = {
      company_name: companyName,
      user_id: userName,
    };
    dispatch(listAvatar(input))
      .unwrap()
      .then(({ data }) => {
        if (JSON.parse(data.aivolvex_control_plane).length > 0) {
          const avatar_details = JSON.parse(data.aivolvex_control_plane).map(
            (datas) => {
              return {
                avatar_name: datas.avatar_name,
                id: datas.id,
                avatar_image: datas.image,
              };
            }
          );
          setavatarname(avatar_details);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleInputChange = (event) => {
    setClicked(true);
    setValue(event);
    const htmlContent = value;
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    const inputValue = tempElement.textContent;
    const words = inputValue.split(" ");
    const lastWord = words[words.length - 1];
    if (lastWord) {
      const updatedData = words.map((item) =>
        item.replace(selectedSuggestion, "").trim()
      );
      const concatenatedString = updatedData.join(" ");
      const filteredSugg = queryqusestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(concatenatedString.toLowerCase())
      );
      setfilteredSuggestionsqus(filteredSugg);
    }

    if (lastWord.startsWith("@") && !showSuggestions) {
      setSearchQuery(lastWord.substr(1));
      setShowSuggestions(true);
      // setSearchQueryStatus(true);
    } else if (!lastWord.startsWith("@") && showSuggestions) {
      // setShowSuggestions(false);
    } else if (lastWord.startsWith("@") && showSuggestions) {
      setSearchQuery(lastWord.substr(1));
      setShowSuggestions(true);
      // setSearchQueryStatus(true);
    }
  };

  const handleSuggestionSelect = (suggestion) => {

    const suggestionIdMap = {};
    for (const avatar of avatarname) {
      suggestionIdMap[avatar.avatar_name] = avatar.id;
    }
    const idno = suggestionIdMap[suggestion];
    if (idno !== undefined) {
      setid(idno);
    }
    setSelectedSuggestion(suggestion);
    setSearchQueryStatus(false);
    setqueryshow(true);
    setValue(
      `<span style='color: rgb(219, 42, 172);'>${suggestion}</span> <span>&nbsp;</span>`
    );


    setAllowListStatus(false);
    setSearchQuery("");
    setMentions([...mentions, suggestion]);
    setSuggestions([]);
  };

  const handleKeyDown = (event) => {

    if (event.key === "@") {
      if (allowlist) {
        setShowSuggestions(true);
        const suggestionList = avatarname.map((item) => item.avatar_name);
        setSuggestions(avatarname);
        setSearchQueryStatus(true);

      }
    } else if (event.key === "Enter" && searchquerystatus) {
      const selectedSuggestion1 = filteredSuggestions[0];
      if (selectedSuggestion1) {
        handleSuggestionSelect(selectedSuggestion1);
      }
    } else if (event.key === "Enter") {
      setClicked(false);
      const htmlContent = value;
      const tempElement = document.createElement("div");
      tempElement.innerHTML = htmlContent;
      const textContent = tempElement.textContent;
      const content = textContent.replace(selectedSuggestion, " ").trim();

      if (content) {
        dispatch(updateLastWord(content));
        dispatch(setLibraryQuestion(content));

        let navigationId = id;
        if (navigationId === undefined) {
          navigationId = 464;
        }
        navigateFn("/conversation/" + navigationId);
        setValue();
        setClicked(false);
      }
    } else if (event.key === "Backspace") {
      const inputValue = event.target.value;
      const htmlContent = value;
      const tempElement = document.createElement("div");
      tempElement.innerHTML = htmlContent;
      const textContent = tempElement.textContent;
      if (textContent?.length === 0) {
        setClicked(false);
        setAllowListStatus(true);
        setShowSuggestions(false);
        setqueryshow(false);
      }
      if (mentions[1]) {
        if (mentions[1] !== "") {
          return;
        } else if (mentions[1] === "") {
          mentions.pop();
        }
      } else {
        if (mentions[0]) {
          if (textContent?.length == mentions[0]?.length) {
            setMentions([]);
            setValue("");
            setAllowListStatus(true);
            setShowSuggestions(false);
            setqueryshow(false);
          }
        }
      }
    }
  };

  const filteredSuggestions = suggestions.filter(
    (suggestion) =>
      suggestion.avatar_name
        .toLowerCase()
        .indexOf(searchQuery.toLowerCase()) !== -1
  );

  useEffect(() => {
    const input = {
      companyname: companyName,
      id: id,
    };
    dispatch(getAvatarLibrary(input))
      .unwrap()
      .then(({ data }) => {

        const datas = JSON.parse(data.aivolvex_control_plane)
      
        const values = datas.map(item => item.avatar_libary);

        setqueryquestions(values);
        setfilteredSuggestionsqus(values);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);
  const handleQuestionclick = (question) => {
    setqueryshow(false);
    setValue(
      `<span style='color: rgb(219, 42, 172);'>${selectedSuggestion}</span> <span>&nbsp;${question}</span>`
    );
  };

  const handleEditorClick = () => {
    setClicked(true);
  };

  return (
    <div className="mention-input-container">
      <ReactQuill
        value={value}
        ref={editorRef}
        onClick={handleEditorClick}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder="@ Interact with your Agent"
        modules={{ toolbar: false }}
        className={`nav-question-search ${clicked ? "expanded" : ""}`}
      />

      {showSuggestions && filteredSuggestions?.length > 0 && (
        <ul className="suggestions-list">
          {filteredSuggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionSelect(suggestion.avatar_name)}
            >
              {/* {suggestion.avatar_image && (
                <span>
                  <img
                    src={suggestion.avatar_image}
                    alt="avatar_icon"
                    className="avatar_icon_image"
                  />
                </span>
              )} */}

              {suggestion.avatar_name}
            </li>
          ))}
        </ul>
      )}
      {queryshow && (
        <ul className="suggestions-list-list">
          {filteredSuggestionsqus.map((question, index) => (
            <li
              key={index}
              className="suggestions-list-item"
              onClick={() => handleQuestionclick(question)}
            >
              {question}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default MentionInputField;
